export const ERR_OK = '200'
export const VIDEO_URL = 'https://sv.static.bingotalk.cn/video/'
export const TIME_ZONE = 'HST,EST,ROC,GMT+0,GMT-0,MST'.split(",");



// WEBPACK FOOTER //
// ./src/api/config.js